import React, { useState, useEffect } from "react";
import WhiteVehicle from "./Assets/whitevehicle.png";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { BaseUrl } from "../../Actions/Base";
import { useDispatch, useSelector } from "react-redux";
import { GetClassStartedOtp } from "../../Actions/InstructorA";

function InstructorInfoDistanceTime({setMinimizeInstructorDetails, minimizeInstructorDetails,
    totalDistance, remainingDistance, expectedArrival, InstructorNameAndOthers,
    data, UserId, EmergencyContacts}) {
    const [otp, setOtp] = useState(new Array(4).fill("")); // Initialize OTP array
    const Border = "border-[#E2E2E2] border-[1px] border-solid";
    console.log("totalDistance for distance is:",totalDistance)
    console.log("remainingDistance for distance is:",remainingDistance)
    console.log("expectedArrival for distance is:",expectedArrival)
    const [ImgUrl, setImgUrl] = useState(null); // State to store the image URL
    const [elapsedTime, setElapsedTime] = useState("00:00");
    const [remainingTime, setRemainingTime] = useState("00:00");
    const [currentDisplay, setCurrentDisplay] = useState({
        heading: "Left Location",
        time: "00:00",
      });
    const [classStartedTime, setClassStartedTime] = useState("");
    const [classEndTime, setClassEndTime] = useState("");

    const Dispatch = useDispatch();

    const { ClassStartedOTP } = useSelector(
      (Store) => Store.InstructorReducer
    );
    console.log("ClassStartedOTP is:",ClassStartedOTP)

    useEffect(() => {
        // Determine the current heading and time based on the data received
        if(data){
        if (data?.data?.CompletedInvehicleClassTime) {
          setCurrentDisplay({
            heading: "End Class",
            time: data?.data?.CompletedInvehicleClassTime,
          });
          setClassEndTime(data?.data?.CompletedInvehicleClassTime)
        } else if (data?.data?.PickupStudentTime) {
          setCurrentDisplay({
            heading: "Class Started",
            time: data.data.PickupStudentTime,
          });
          setClassStartedTime(data.data.PickupStudentTime)
        } else if (data?.data?.ReachedLocationTime) {
          setCurrentDisplay({
            heading: "At Pickup Zone",
            time: data.data.ReachedLocationTime,
          });
        } else if (data?.data?.LeftLocationTime) {
          setCurrentDisplay({
            heading: "Left Location",
            time: data.data.LeftLocationTime,
          });
        } else {
          setCurrentDisplay({
            heading: "Left Location",
            time: "00:00",
          });
        }
    }
      }, [data]);

    // Fetch OTP when component mounts or when "At Pickup Zone" is detected
    useEffect(() => {
      if (currentDisplay.heading === "At Pickup Zone") {
        Dispatch(GetClassStartedOtp(UserId)); // Fetch OTP
      }
    }, [currentDisplay, UserId]); // Run when heading changes or UserId updates

      // Update OTP input fields when new OTP is received
    useEffect(() => {
      if (ClassStartedOTP?.data?.ClassOTP) {
        const otpRetrieved = ClassStartedOTP.data.ClassOTP.toString(); // Ensure it's a string
        setOtp(otpRetrieved.split("").slice(0, 4)); // Convert to array & limit to 4 digits
      }
    }, [ClassStartedOTP]); // Run when ClassStartedOTP updates

    useEffect(() => {
        if (InstructorNameAndOthers?.ProfileImage) {
            const instructorProfile = InstructorNameAndOthers?.ProfileImage;
            console.log("instructorProfile is:",instructorProfile)
            const imgUrl = `${BaseUrl}/api/images/Instructors?url=${instructorProfile}`;
            console.log("imgUrl is:",imgUrl)
            setImgUrl(imgUrl); // Update state with the URL
        }
    }, [InstructorNameAndOthers]);

    useEffect(() => {
      let interval;
    
      if (currentDisplay.heading === "Class Started") {
        if (ClassStartedOTP?.data?.startDate && ClassStartedOTP.data.endDate) {
          const startTime = new Date(ClassStartedOTP.data.startDate).getTime();
          const endTime = new Date(ClassStartedOTP.data.endDate).getTime();
          const totalDuration = Math.floor((endTime - startTime) / 1000); // Convert to seconds
          console.log("Total duration of the class:", totalDuration);
    
          // Get stored elapsed and remaining time
          let storedElapsed = parseInt(localStorage.getItem("elapsedTime"), 10) || 0;
          let storedRemaining = parseInt(localStorage.getItem("remainingTime"), 10) || totalDuration - storedElapsed;
    
          // Ensure valid values
          storedElapsed = Math.min(storedElapsed, totalDuration);
          storedRemaining = Math.max(totalDuration - storedElapsed, 0);
    
          const formatTime = (seconds) => {
            let minutes = Math.floor(seconds / 60);
            let secs = seconds % 60;
            return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
          };
    
          setElapsedTime(formatTime(storedElapsed));
          setRemainingTime(formatTime(storedRemaining));
    
          interval = setInterval(() => {
            // Stop timer if currentDisplay.heading is changed
            if (currentDisplay.heading !== "Class Started") {
              clearInterval(interval);
              return;
            }
    
            setElapsedTime((prevElapsed) => {
              const newElapsed = parseInt(prevElapsed.split(":")[0]) * 60 + parseInt(prevElapsed.split(":")[1]) + 1;
              localStorage.setItem("elapsedTime", newElapsed);
              return formatTime(newElapsed);
            });
    
            setRemainingTime((prevRemaining) => {
              const newRemaining = parseInt(prevRemaining.split(":")[0]) * 60 + parseInt(prevRemaining.split(":")[1]) - 1;
              localStorage.setItem("remainingTime", newRemaining);
    
              return newRemaining > 0 ? formatTime(newRemaining) : "00:00";
            });
          }, 1000);
        }
      }
    
      return () => clearInterval(interval); // Cleanup on component unmount or dependency change
    }, [ClassStartedOTP, currentDisplay]);
    
  

    const handleMinimizeClick = () =>{
        setMinimizeInstructorDetails(!minimizeInstructorDetails)
      }

  return (
    <div className="w-full fixed lg:hidden p-[20px]  bottom-0 left-0 z-[999]">
        <div className="w-[330px] p-[10px] rounded-[11px] bg-[#A1A3EF] bg-opacity-60 backdrop-blur-[6px] backdrop-brightness-50 relative" >
            <div className="absolute right-[10px] top-[5px]">
                    <button className="bg-[#FFFFFF] rounded-[5px] text-[#4C34AD] text-[10px] h-[20px] w-[65px]"
                     onClick={handleMinimizeClick} >
                        {!minimizeInstructorDetails ? <KeyboardArrowDownIcon sx={{ color: '#4C34AD', fontSize: 20 }} /> :  <KeyboardArrowUpIcon sx={{ color: '#4C34AD', fontSize: 20 }} /> }
                        {minimizeInstructorDetails ? "Maximize" : "Minimize"}
                    </button>
            </div>
            
            {!minimizeInstructorDetails && (
                <div className="flex gap-[20px]">
                    <div className="w-[90px] h-[80px] flex items-center justify-center overflow-hidden rounded-[19px] relative">
                         <img
                            className="absolute w-full rounded-[19px]"
                            src={ImgUrl}
                            alt={"instructorimg"}
                        />  
                    </div>
                    <div className="flex- flex-col">
                        <p className="text-[16px] text-[#FFFFFF] font-bold">{InstructorNameAndOthers?.FirstName} {InstructorNameAndOthers?.LastName}</p>
                        <p className="text-[16px] text-[#FFFFFF] mt-[15px]">{EmergencyContacts?.CourseName}</p>
                        <p className="text-[16px] text-[#FFFFFF]">Class ID: {InstructorNameAndOthers?.classId}</p>
                        {/* <p className="text-[16px] text-[#FFFFFF] w-[180px] mt-[15px]">Special License of Class  {InstructorNameAndOthers?.RegularLicenses.join(", ")},{InstructorNameAndOthers?.SpecialLicenses.join(", ")} Licensing.</p> */}
                    </div>
                </div>
            )}

            {currentDisplay.heading==="Left Location" && (
              <>
                <div className="flex justify-between items-center gap-[15px] mt-[15px] px-[5px]">
                    <div className="flex flex-col justify-center items-center gap-[10px] bg-white px-[5px] w-[75px] h-[71px] rounded-[12px]">
                        <p className="text-[12px] text-[#A1A3EF] text-center">{currentDisplay.heading}</p>
                        <p className="text-[12px] text-[#A1A3EF] font-bold text-center">{currentDisplay.time}</p>
                    </div>

                    <div className="flex flex-col gap-[10px]">
                        <p className="text-[12px] text-[#FFFFFF] text-center">Total Distance</p>
                        <p className="text-[12px] text-[#FFFFFF] font-bold text-center">{totalDistance}</p>
                    </div>

                    <div className="flex flex-col gap-[10px]">
                        <p className="text-[12px] text-[#FFFFFF] text-center">Remaining Distance</p>
                        <p className="text-[12px] text-[#FFFFFF] font-bold text-center">{remainingDistance}</p>
                    </div>

                    <div className="flex flex-col gap-[10px] px-[2px] py-[5px] rounded-[12px]"
                    style={{
                      border:"1px solid #FFFFFF"
                    }}>
                        <p className="text-[12px] text-[#FFFFFF] text-center">Expected Arrival</p>
                        <p className="text-[12px] text-[#FFFFFF] font-bold text-center">{expectedArrival}</p>
                    </div>
                </div>

                <div className="w-full flex items-center mt-[10px] px-[5px]">
                    <p className="text-[10px] text-[#FFFFFF] w-[20px] text-center">Left Location</p>
                    <div className="h-[5px] w-[220px] bg-white rounded-[3px] mx-[5px] relative ml-[20px]" >
                    {currentDisplay.heading==="Left Location" && (
                      <img src={WhiteVehicle} alt="phone" className="absolute left-[0px] top-[-11px]" />
                    )}
                    {currentDisplay.heading==="At Pickup Zone" && (
                      <img src={WhiteVehicle} alt="phone" className="absolute left-[100px] top-[-11px]" />
                    )}
                    {currentDisplay.heading==="Picked Student" && (
                      <img src={WhiteVehicle} alt="phone" className="absolute left-[195px] top-[-11px]" />
                    )}
                    </div>
                    <p className="text-[10px] text-[#FFFFFF] w-[20px] text-center">Pickup Zone</p>
                </div>
              </>
            )}

            {currentDisplay.heading==="At Pickup Zone" && (
              <>
                <div className="flex justify-between items-center gap-[15px] mt-[15px] px-[5px]">
                    <div className="flex flex-col justify-center items-center gap-[10px] bg-white px-[5px] py-[10px] rounded-[12px]">
                        <p className="text-[12px] text-[#A1A3EF] text-center">{currentDisplay.heading}</p>
                        <p className="text-[12px] text-[#A1A3EF] font-bold text-center">{currentDisplay.time}</p>
                    </div>

                    <div className="flex flex-col justify-end gap-[10px]">
                      <p className="text-[12px] text-[#FFFFFF] text-center">
                        {otp.some((digit) => digit !== "") ? "Share OTP with Instructor only" : "Waiting for Instructor"}
                      </p>

                      <div className="flex justify-center items-center gap-[5px]">
                        {otp.map((value, index) => (
                          <input
                            key={index}
                            id={`otp-input-${index}`}
                            type="text"
                            maxLength={1}
                            value={value}
                            readOnly // ✅ Corrected readOnly attribute
                            className={`w-[35px] h-[50px] rounded-md ${Border} font-bold shadow-[4px_5px_6px_#00000029] text-[#A1A3EF] text-center`}
                          />
                        ))}
                      </div>
                    </div>

                    <div className="flex flex-col gap-[10px] px-[2px] py-[15px] rounded-[12px]"
                    style={{
                      border:"1px solid #FFFFFF"
                    }}>
                        <p className="text-[12px] text-[#FFFFFF] text-center">Pickup Student</p>
                        <p className="text-[12px] text-[#FFFFFF] font-bold text-center">-</p>
                    </div>
                </div>

                <div className="w-full flex items-center mt-[10px] px-[5px]">
                    <p className="text-[10px] text-[#FFFFFF] w-[20px] text-center">At Pickup Zone</p>
                    <div className="h-[5px] w-[220px] bg-white rounded-[3px] mx-[5px] relative ml-[20px]" >
                    {currentDisplay.heading==="At Pickup Zone" && (
                      <img src={WhiteVehicle} alt="phone" className="absolute left-[100px] top-[-11px]" />
                    )}
                    {currentDisplay.heading==="Picked Student" && (
                      <img src={WhiteVehicle} alt="phone" className="absolute left-[195px] top-[-11px]" />
                    )}
                    </div>
                    <p className="text-[10px] text-[#FFFFFF] w-[20px] text-center">Class Initiate</p>
                </div>
              </>
            )}

             {(currentDisplay.heading==="Class Started" || currentDisplay.heading==="End Class") && (
              <>
                <div className="flex justify-between items-center gap-[15px] mt-[15px] px-[5px]">
                    <div className="flex flex-col justify-center items-center gap-[10px] bg-white px-[5px] py-[10px] rounded-[12px]">
                        <p className="text-[12px] text-[#A1A3EF] text-center">Start Class</p>
                        <p className="text-[12px] text-[#A1A3EF] font-bold text-center">{classStartedTime}</p>
                    </div>

                    <div className="flex flex-col gap-[10px] px-[2px] py-[10px] rounded-[12px]"
                    style={{
                      border:"1px solid #FFFFFF"
                    }}>
                        <p className="text-[12px] text-[#FFFFFF] text-center">Elapsed Time</p>
                        <p className="text-[12px] text-[#FFFFFF] font-bold text-center">{elapsedTime}</p>
                    </div>

                    <div className="flex flex-col gap-[10px] py-[10px] rounded-[12px]"
                    style={{
                      border:"1px solid #FFFFFF"
                    }}>
                        <p className="text-[12px] text-[#FFFFFF] text-center">Remaining Time</p>
                        <p className="text-[12px] text-[#FFFFFF] font-bold text-center">{remainingTime}</p>
                    </div>

                    <div className="flex flex-col gap-[10px] px-[2px] py-[10px] rounded-[12px]"
                    style={{
                      border:"1px solid #FFFFFF"
                    }}>
                        <p className="text-[12px] text-[#FFFFFF] text-center">End Class</p>
                        <p className="text-[12px] text-[#FFFFFF] font-bold text-center">{classEndTime ? classEndTime : "-"}</p>
                    </div>
                </div>

                <div className="w-full flex items-center mt-[10px] px-[5px]">
                    <p className="text-[10px] text-[#FFFFFF] w-[20px] text-center">Class Started</p>
                    <div className="h-[5px] w-[220px] bg-white rounded-[3px] mx-[5px] relative ml-[20px]" >
                      {currentDisplay.heading==="Class Started" && (
                        <img src={WhiteVehicle} alt="phone" className="absolute left-[150px] top-[-11px]" />
                      )}

                      {currentDisplay.heading==="End Class" && (
                      <img src={WhiteVehicle} alt="phone" className="absolute left-[195px] top-[-11px]" />
                    )}
                    </div>
                    <p className="text-[10px] text-[#FFFFFF] w-[20px] text-center">End Class</p>
                </div>
              </>
            )}

           
        </div>   
    </div>
  );
}

export default InstructorInfoDistanceTime;
